import type { DateFormat } from '~common/utils/date-transformation/types'

function pad2(n: number): string {
    return n < 10 ? `0${n}` : `${n}`
}

export function formatTimestampForDisplay(
    timestamp: number,
    format: DateFormat,
): string {
    return formatDateForDisplay(new Date(timestamp), format)
}

export function formatDateForDisplay(date: Date, format: DateFormat): string {
    const isoString = date.toISOString()
    return formatISODate(isoString, format)
}

export function formatISODate(dateISO: string, format: DateFormat): string {
    // Parse the ISO date string (YYYY-MM-DD)
    const year = parseInt(dateISO.slice(0, 4), 10)
    const month = parseInt(dateISO.slice(5, 7), 10)
    const day = parseInt(dateISO.slice(8, 10), 10)

    // Month names for formats that use MMM
    const monthNames = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ]

    const monthName = monthNames[month - 1]
    const paddedMonth = pad2(month)
    const paddedDay = pad2(day)

    switch (format) {
        case 'MM/DD/YYYY':
            return `${paddedMonth}/${paddedDay}/${year}`
        case 'DD/MM/YYYY':
            return `${paddedDay}/${paddedMonth}/${year}`
        case 'YYYY-MM-DD':
            return `${year}-${paddedMonth}-${paddedDay}`
        case 'DD.MM.YYYY':
            return `${paddedDay}.${paddedMonth}.${year}`
        case 'MM-DD-YYYY':
            return `${paddedMonth}-${paddedDay}-${year}`
        case 'DD-MM-YYYY':
            return `${paddedDay}-${paddedMonth}-${year}`
        case 'YYYY/MM/DD':
            return `${year}/${paddedMonth}/${paddedDay}`
        case 'MMM DD, YYYY':
            return `${monthName} ${paddedDay}, ${year}`
        case 'DD MMM YYYY':
            return `${paddedDay} ${monthName} ${year}`
        case 'YYYY年MM月DD日':
            return `${year}年${paddedMonth}月${paddedDay}日`
        default:
            // This should never happen if DateFormat is used correctly
            throw new Error(`Unsupported date format: ${format}`)
    }
}
